var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M775.8 203.5L511.3 467.9 248.3 205c-3.9-3.9-10.2-3.9-14.1 0l-31.1 31c-3.9 3.9-3.9 10.2 0 14.1l262.9 263-263 263c-3.9 3.9-3.9 10.2 0 14.1l31.2 31.2c3.9 3.9 10.2 3.9 14.1 0l263-263L775.8 823c3.9 3.9 10.2 3.9 14.1 0l31.2-31.2c3.9-3.9 3.9-10.2 0-14.1L556.6 513.2 821 248.7c3.9-3.9 3.9-10.2 0-14.1l-31-31.1c-3.9-3.9-10.3-3.9-14.2 0z"}));
}

IconClose.displayName = "IconClose";

IconClose.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconClose;

IconClose.default = IconClose;
